// extracted by mini-css-extract-plugin
export default {"header":"RealTimeTrendDetails_header__MWva-","infoContainer":"RealTimeTrendDetails_infoContainer__dP4Xe"};